import { organizerAvailableTitle } from 'owa-calendar-forms-common/lib/strings.locstring.json';
import {
    organizerFreeBusyTitle,
    attendeeStatusUnknownTitle,
    attendeeStatusTitle,
    attendeeAvailableStatusTitle,
} from './PersonaWithFbBadge.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { RoomIcon } from 'owa-room-control';

import { FreeBusyType, isConflictFromFreeBusy, freeBusyCache } from 'owa-freebusy-cache';
import { getComposeCalendarColorScheme } from 'owa-calendar-compose-form-store/lib/selectors/getComposeCalendarColorScheme';
import { PersonaSize } from '@fluentui/react/lib';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { observer } from 'mobx-react-lite';
import { FreeBusyBadgeBase } from 'owa-calendar-meeting-forms-common-view';

let styles = require('./FreeBusySummary.scss');

export interface FreeBusyBadgeProps {
    attendee: AttendeeType;
    isResource: boolean;
    event: CalendarEvent;
    originalEvent: CalendarEvent;
}

const isSelf = (attendee: AttendeeType) => {
    const selfEmailAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
    return attendee.Mailbox.EmailAddress == selfEmailAddress;
};

const getTitle = (attendee: AttendeeType, freeBusy: FreeBusyType, isResource: boolean) => {
    if (isSelf(attendee)) {
        if (isConflictFromFreeBusy(freeBusy, isResource)) {
            return loc(organizerFreeBusyTitle);
        }
        return loc(organizerAvailableTitle);
    }
    if (freeBusy == FreeBusyType.NoData) {
        return format(loc(attendeeStatusUnknownTitle), attendee.Mailbox.Name);
    }
    if (isConflictFromFreeBusy(freeBusy, isResource)) {
        return format(loc(attendeeStatusTitle), attendee.Mailbox.Name);
    }
    return format(loc(attendeeAvailableStatusTitle), attendee.Mailbox.Name);
};

/**
 * A Persona coin control with a badge that represents freebusy
 */
const PersonaWithFbBadge: React.SFC<FreeBusyBadgeProps> = observer(props => {
    let { attendee, isResource, event, originalEvent } = props;
    let attendeeMailbox = attendee.Mailbox;

    const { Start, End, IsAllDayEvent } = event;

    const status = freeBusyCache.getAggregatedFreeBusy(
        attendee.Mailbox.EmailAddress,
        Start,
        End,
        IsAllDayEvent,
        originalEvent
    );

    const colorScheme = getComposeCalendarColorScheme();
    const title = getTitle(attendee, status, isResource);

    return (
        <div className={styles.persona} aria-label={title} role="listitem">
            <TooltipHost content={title}>
                {isResource ? (
                    <RoomIcon colorScheme={colorScheme} />
                ) : (
                    <PersonaControl
                        emailAddress={attendeeMailbox.EmailAddress}
                        name={attendeeMailbox.Name}
                        size={PersonaSize.size32}
                        showPresence={false}
                        mailboxType={attendeeMailbox.MailboxType}
                    />
                )}
            </TooltipHost>
            <FreeBusyBadgeBase freeBusyType={status} isResource={isResource} />
        </div>
    );
});

export default PersonaWithFbBadge;
